import React from "react";

type Props = {
  color?: React.CSSProperties["color"];
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  rotation?: number;
};

const ArrowWithTail = ({
  width = 13,
  height = 10,
  color = "#fff",
  rotation = 0,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <path
        d="M7.72005 1.52991C7.64636 1.46125 7.58726 1.37845 7.54627 1.28645C7.50528 1.19445 7.48323 1.09513 7.48146 0.994432C7.47968 0.893729 7.49821 0.7937 7.53593 0.700312C7.57365 0.606923 7.62979 0.52209 7.70101 0.450871C7.77223 0.379652 7.85706 0.323508 7.95045 0.285787C8.04384 0.248066 8.14387 0.229541 8.24457 0.231318C8.34527 0.233095 8.44459 0.255136 8.53659 0.296128C8.62859 0.33712 8.71139 0.396222 8.78005 0.469909L12.78 4.46991C12.9205 4.61054 12.9994 4.80116 12.9994 4.99991C12.9994 5.19866 12.9205 5.38928 12.78 5.52991L8.78005 9.52991C8.71139 9.6036 8.62859 9.6627 8.53659 9.70369C8.44459 9.74468 8.34527 9.76672 8.24457 9.7685C8.14387 9.77028 8.04384 9.75175 7.95045 9.71403C7.85706 9.67631 7.77223 9.62017 7.70101 9.54895C7.62979 9.47773 7.57365 9.39289 7.53593 9.29951C7.49821 9.20612 7.47968 9.10609 7.48146 9.00539C7.48323 8.90468 7.50528 8.80537 7.54627 8.71337C7.58726 8.62137 7.64636 8.53857 7.72005 8.46991L10.44 5.74991L0.75005 5.74991C0.551137 5.74991 0.360372 5.67089 0.219719 5.53024C0.0790663 5.38959 4.95911e-05 5.19882 4.95911e-05 4.99991C4.95911e-05 4.801 0.0790663 4.61023 0.219719 4.46958C0.360372 4.32893 0.551137 4.24991 0.75005 4.24991L10.44 4.24991L7.72005 1.52991Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowWithTail;
